module.exports = __webpack_public_path__ + "f4f3a1576084e5e082f212c7a8cfd4ec.png";